import React, { useEffect } from "react";
import { Box, MenuItem, TextField } from "@mui/material";

interface TimeRangeSelectorProps {
  timeRange: string;
  setTimeRange: (value: string) => void;
  customStartDate: string;
  setCustomStartDate: (value: string) => void;
  customEndDate: string;
  setCustomEndDate: (value: string) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ timeRange, setTimeRange, customStartDate, setCustomStartDate, customEndDate, setCustomEndDate }) => {
  useEffect(() => {
    // Only trigger data updates after both custom dates are selected
    if (timeRange === "custom" && customStartDate && customEndDate) {
      // This automatically triggers re-fetch via useOrders hook
    }
  }, [customStartDate, customEndDate, timeRange]);

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      <TextField select label="Time Range" value={timeRange} onChange={(e) => setTimeRange(e.target.value)} size="small">
        <MenuItem value="today">Today</MenuItem>
        <MenuItem value="yesterday">Yesterday</MenuItem>
        <MenuItem value="week">This Week</MenuItem>
        <MenuItem value="month">This Month</MenuItem>
        <MenuItem value="year">This Year</MenuItem>
        <MenuItem value="custom">Custom</MenuItem>
      </TextField>

      {timeRange === "custom" && (
        <>
          <TextField type="date" label="Start Date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} InputLabelProps={{ shrink: true }} size="small" />
          <TextField type="date" label="End Date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} InputLabelProps={{ shrink: true }} size="small" />
        </>
      )}
    </Box>
  );
};

export default TimeRangeSelector;
